module.exports = __webpack_public_path__ + "img/VTAFvs15.388683e8.png";